import { motion } from "framer-motion";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";
import { PROCESS } from "@/data/site";

export const Process = () => {
  return (
    <section
      id="ablauf"
      data-testid="process-section"
      className="relative border-y"
      style={{ borderColor: "var(--lx-border)", background: "rgba(11,15,12,0.5)" }}
    >
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
        <div className="mb-12 max-w-2xl">
          <div className="lx-kicker mb-3">Unser Ablauf</div>
          <h2 className="font-display text-2xl font-semibold tracking-tight text-[color:var(--lx-text)] sm:text-3xl lg:text-4xl">
            Ein klarer Weg von der Idee zum Launch.
          </h2>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5"
        >
          {PROCESS.map((p) => (
            <motion.div
              key={p.step}
              variants={fadeUp}
              data-testid="process-step"
              className="lx-card flex flex-col p-6"
            >
              <div
                className="font-mono-lx text-sm"
                style={{ color: "var(--lx-bronze-2)" }}
              >
                {p.step}
              </div>
              <h3 className="mt-3 font-display text-base font-semibold text-[color:var(--lx-text)]">
                {p.title}
              </h3>
              <ul className="mt-3 space-y-1.5">
                {p.points.map((pt) => (
                  <li
                    key={pt}
                    className="text-xs leading-relaxed text-[color:var(--lx-text-2)]"
                  >
                    {pt}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
